import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=48f8459c"
import script from "./ActivityTable.vue?vue&type=script&lang=js"
export * from "./ActivityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports